// VH-67: Aggregated totals for multi-week ranges. Hidden when range == 1 week.
import { useTranslation } from 'react-i18next'
import { ChartBarIcon } from '@heroicons/react/24/outline'

function fmt(value, opts = {}) {
  if (value == null || Number.isNaN(value)) return '--'
  if (opts.round) return Math.round(value).toLocaleString()
  if (typeof opts.fractionDigits === 'number') return Number(value).toFixed(opts.fractionDigits)
  return Number(value).toLocaleString()
}

export default function RangeTotalsCard({ totals, weekCount }) {
  const { t } = useTranslation()
  if (!totals || !weekCount || weekCount < 2) return null

  const nutrition = totals.nutrition || {}
  const activity = totals.activity || {}
  const exercise = totals.exercise || {}

  return (
    <div className="card">
      <div className="card-body">
        <div className="flex items-center gap-2 mb-3">
          <ChartBarIcon className="h-5 w-5 text-primary-600" />
          <h3 className="text-lg font-semibold text-gray-900">
            {t('reports.range.totalsTitle')}
          </h3>
          <span className="ml-auto text-sm text-gray-500">
            {t('reports.range.weeksCovered')}: {weekCount}
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="text-center">
            <p className="text-xs text-gray-500">{t('reports.weekly.avgCalories')}</p>
            <p className="text-xl font-bold text-gray-900">
              {fmt(nutrition.avg_calories, { round: true })}
              <span className="text-xs font-normal text-gray-500 ml-1">
                {t('reports.weekly.kcal')}
              </span>
            </p>
          </div>
          <div className="text-center">
            <p className="text-xs text-gray-500">{t('reports.weekly.avgSteps')}</p>
            <p className="text-xl font-bold text-gray-900">
              {fmt(activity.avg_steps, { round: true })}
            </p>
          </div>
          <div className="text-center">
            <p className="text-xs text-gray-500">{t('reports.weekly.sessionsCompleted')}</p>
            <p className="text-xl font-bold text-gray-900">
              {fmt(exercise.total_sessions, { round: true })}
            </p>
          </div>
          <div className="text-center">
            <p className="text-xs text-gray-500">{t('reports.weekly.newPRs')}</p>
            <p className="text-xl font-bold text-gray-900">
              {fmt(exercise.total_new_prs, { round: true })}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
